module.exports = "/assets//img/277c025f3ea7311d0109a1d3845ec1c3.png";